import { createContext, useContext } from 'react';
import { BundledTicket, Ticket } from 'types/domain';

interface ITicketActionsContext {
    ticket: Ticket | BundledTicket;
}

const TicketActionsContext = createContext<ITicketActionsContext | undefined>(undefined);
const useTicketActionsContext = () => {
    const context = useContext(TicketActionsContext);
    if (!context) {
        throw new Error('useTicketActionsContext must be used within a TicketActionsProvider');
    }
    return context;
};

export { useTicketActionsContext, TicketActionsContext };
export type { ITicketActionsContext };
